import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const AmountDiv = styled.div`
  font-weight: bold;
`;

const getCurrencyEuroFormatter = (options = {}) => {
  return Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    ...options,
  });
};

export const formatAmount = (amount, options = {}) => {
  return getCurrencyEuroFormatter(options).format(amount / 100);
};

const DisplayAmount = ({amount, amountOptions = {}, ...props}) => {
  return <AmountDiv {...props}>{formatAmount(amount, amountOptions)}</AmountDiv>;
};

DisplayAmount.propTypes = {
  amount: PropTypes.number.isRequired,
  amountOptions: PropTypes.object,
};

export default (DisplayAmount);
